import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import app from "funkis-foundation/redux/reducers/appReducer";
import config from "funkis-foundation/redux/reducers/configReducer";
import location from "funkis-foundation/redux/reducers/locationReducer";
import pageItems from "funkis-foundation/redux/reducers/pageItemsReducer";
import pages from "funkis-foundation/redux/reducers/pagesReducer";
import subtitles from "funkis-foundation/redux/reducers/subtitlesReducer";
import texts from "funkis-foundation/redux/reducers/textsReducer";
import timers from "funkis-foundation/redux/reducers/timersReducer";
import {
	groupsReducer,
	membersReducer,
	quiddityEventsReducer,
	quiddityReducer,
	quidditySessionsReducer,
	quidInputsReducer,
	quidsReducer,
	unitsReducer,
	usersReducer,
} from "quiddity";
import analyticsMiddleware from "./analyticsMiddleware";

export const store = configureStore({
	reducer: {
		config,
		location,
		pages,
		pageItems,
		app,
		texts,
		subtitles,
		timers,

		quiddity: quiddityReducer,
		quids: quidsReducer,
		groups: groupsReducer,
		users: usersReducer,
		units: unitsReducer,
		members: membersReducer,
		quidInputs: quidInputsReducer,
		quiddityEvents: quiddityEventsReducer,
		quidditySessions: quidditySessionsReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(analyticsMiddleware),
});

setupListeners(store.dispatch);
